// extracted by mini-css-extract-plugin
module.exports = {"container":"ChooseFeedTypeList_container__2-Pie","header":"ChooseFeedTypeList_header__QO3Nt","iconContainer":"ChooseFeedTypeList_iconContainer__12AIJ"};